import { ProductOld } from 'src/admin-entity/interface/product/product-old.interface';
import { ProductTagGroup } from 'src/admin-entity/interface/product/product-tag-group.interface';

interface ProductsInTag {
    selectedGroupId: number;
    page: {
        count: number;
    };
    products: ProductOld[];
}

export interface ProductTagSliceInitType {
    tagGroups: ProductTagGroup[];
    childrenTags: { id: number; tag: string }[];
    selectedParentTagGroup: ProductTagGroup;
    selectedChildTag: { id: number; tag: string };
    productsInTag?: ProductsInTag;
    page: number;
    take: number;
}

export const initialState: ProductTagSliceInitType = {
    tagGroups: [],
    childrenTags: [],
    selectedParentTagGroup: {
        id: 0,
        title: '',
        children: [],
    },
    selectedChildTag: {
        id: 0,
        tag: '',
    },
    productsInTag: {
        selectedGroupId: 0,
        page: {
            count: 0,
        },
        products: [],
    },
    page: 0,
    take: 10,
};
